import { Button, Col, Form, Modal, Row, Space, Typography } from "antd";
import { InputFields, Notification } from "components/common";
import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import { dataField } from "./ModalDetail.config";

import "./style.scss";
import TruocDieuTri from "./components/TruocDieuTri";
import Fitting from "./components/Fitting";
import KetQuaDieuTri from "./components/KetQuaDieuTri";
import { refraction } from "api";
import { removeEmpty } from "helper/refraction";
import { convertIosStringToDateObjectDayjs } from "helper/common";
import { useAppDispatch } from "redux/hooks";
import { setIdRefraction } from "redux/reducer/pending";
import { setDataOrthoK as setData } from "redux/reducer/pending";

const ModalDetail = React.forwardRef((props: any, ref) => {
  const { getData } = props;
  const [form] = Form.useForm();
  const [dataOthorK, setDataOthorK] = useState<any>();
  const [isShowModal, setIsShowModal] = useState(false);
  const [typeModal, setTypeModal] = useState(true);
  const [dataTable, setDataTable] = useState(null);
  const [fielOthorK, setFieldOthorK] = useState(dataField);
  const kqdtRef = useRef<any>();
  useImperativeHandle(ref, () => ({
    setDataOthorK: setDataOthorK,
    setIsShowModal: setIsShowModal,
    setTypeModal: setTypeModal,
    setDataTable: setDataTable,
  }));

  useEffect(() => {
    if (dataTable) {
      kqdtRef.current.setDataTable(dataTable);
    }
  }, [dataTable]);
  const fetchData = async () => {
    try {
      const res = await refraction.getListDataOthorK({
        page: 1,
        limit: 50,
      });
      dispatch(setData(res));
    } catch (error) {
      Notification("error", "Không lấy được danh sách bệnh nhân");
    }
  };
  // const fomartParams = () => {
  //   return {
  //     ngayNhanKinhStart: formatDateToString(dayjs()),
  //     ngayNhanKinhEnd: formatDateToString(dayjs()),
  //   };
  // };
  // const fetchData = async () => {
  //   try {
  //     const res = await refraction.getListDataOthorK(fomartParams());
  //   } catch (error) {
  //     Notification("error", "Không lấy được danh sách bệnh nhân");
  //   }
  // };
  const handleSubmit = async () => {
    if (!form.getFieldValue("maBenhNhan")) {
      Notification("warning", "Chưa nhập mã bệnh nhân");
    } else {
      const data = form.getFieldsValue();
      const kqdt = data.ketQuaDieuTriOrthoK;

      const convertData = {
        ...dataOthorK,
        ...data,
        fitting: removeEmpty(data?.fitting),
        ketQuaDieuTriOrthoK: kqdt?.filter((e) =>
          Object.values(e).some(
            (value) => value !== undefined && value !== null
          )
        ),
        ttTruocDieuTri: removeEmpty(data?.ttTruocDieuTri),
      };
      try {
        if (typeModal) {
          // fetchData();
          await refraction.postOthorK(convertData);
        } else {
          // getData();

          await refraction.putOthorK(convertData);
        }
        fetchData();
        // dispatch(setCallApiListOrthoK(true));
        Notification("success", `${typeModal ? "Lưu" : "Cập nhật"} thành công`);
        handleCancel();
      } catch (error) {
        console.log("🚀 ~ handleSubmit ~ error:", error);
        Notification(
          "error",
          `${typeModal ? "Lưu" : "Cập nhật"} không thành công`
        );
      }
    }
  };
  const handleCancel = () => {
    setIsShowModal(false);
    setTypeModal(true);
    dispatch(setIdRefraction(null));
    // dispatch(setCallApiListOrthoK(false));

    form.resetFields();
  };

  const dispatch = useAppDispatch();

  useEffect(() => {
    form.resetFields();
    if (typeModal) {
      form.setFieldsValue({
        ...dataOthorK,
        ttTruocDieuTri: {
          mp: {
            0: dataOthorK?.dryRefraction?.right?.tb1?.ucva?.[0],
            1:
              (dataOthorK?.dryAutoRefractionDtos?.right?.sph?.[0]
                ? dataOthorK?.dryAutoRefractionDtos?.right?.sph?.[0] + "/"
                : "") +
              (dataOthorK?.dryAutoRefractionDtos?.right?.cyl?.[0]
                ? dataOthorK?.dryAutoRefractionDtos?.right?.cyl?.[0] + "x"
                : "") +
              (dataOthorK?.dryAutoRefractionDtos?.right?.axis?.[0] ?? ""),
            2: {
              0:
                (dataOthorK?.dryRefraction?.right?.tb1?.sph?.[0]
                  ? dataOthorK?.dryRefraction?.right?.tb1?.sph?.[0] + "/"
                  : "") +
                (dataOthorK?.dryRefraction?.right?.tb1?.cyl?.[0]
                  ? dataOthorK?.dryRefraction?.right?.tb1?.cyl?.[0] + "x"
                  : "") +
                (dataOthorK?.dryRefraction?.right?.tb1?.axis?.[0] ?? ""),
              1: dataOthorK?.dryRefraction?.right?.tb1?.vision?.[0],
            },
          },
          mt: {
            0: dataOthorK?.dryRefraction?.left?.tb1?.ucva?.[0],
            1:
              (dataOthorK?.dryAutoRefractionDtos?.left?.sph?.[0]
                ? dataOthorK?.dryAutoRefractionDtos?.left?.sph?.[0] + "/"
                : "") +
              (dataOthorK?.dryAutoRefractionDtos?.left?.cyl?.[0]
                ? dataOthorK?.dryAutoRefractionDtos?.left?.cyl?.[0] + "x"
                : "") +
              (dataOthorK?.dryAutoRefractionDtos?.left?.axis?.[0] ?? ""),
            2: {
              0:
                (dataOthorK?.dryRefraction?.left?.tb1?.sph?.[0]
                  ? dataOthorK?.dryRefraction?.left?.tb1?.sph?.[0] + "/"
                  : "") +
                (dataOthorK?.dryRefraction?.left?.tb1?.cyl?.[0]
                  ? dataOthorK?.dryRefraction?.left?.tb1?.cyl?.[0] + "x"
                  : "") +
                (dataOthorK?.dryRefraction?.left?.tb1?.axis?.[0] ?? ""),
              1: dataOthorK?.dryRefraction?.left?.tb1?.vision?.[0],
            },
          },
          ketQuaDieuTriOrthoK: dataOthorK?.ketQuaDieuTriOrthoK,
        },

        fitting: dataOthorK?.fitting ? JSON.parse(dataOthorK?.fitting) : "",
        ngayKham: convertIosStringToDateObjectDayjs(dataOthorK?.thoiGianKham),
        ngaySinh: convertIosStringToDateObjectDayjs(dataOthorK?.ngaySinh),
        ngayNhanKinh: convertIosStringToDateObjectDayjs(
          dataOthorK?.ngayNhanKinh
        ),
        ngayKhamGanNhat: convertIosStringToDateObjectDayjs(
          dataOthorK?.ngayKhamGanNhat
        ),
        ngayGoi: convertIosStringToDateObjectDayjs(dataOthorK?.ngayGoi),
        nhanVien: dataOthorK?.tenBsThucHien,
        diaChi: dataOthorK?.diaChiTongHop,
        soDienThoai: dataOthorK?.phoneNumber,
      });
      setFieldOthorK([...fielOthorK]);
    } else {
      setFieldOthorK([...fielOthorK]);

      form.setFieldsValue({
        ...dataOthorK,
        ttTruocDieuTri: dataOthorK?.ttTruocDieuTri
          ? JSON.parse(dataOthorK?.ttTruocDieuTri)
          : "",
        fitting: dataOthorK?.fitting ? JSON.parse(dataOthorK?.fitting) : "",
        ngayKham: convertIosStringToDateObjectDayjs(dataOthorK?.ngayKham),
        ngaySinh: convertIosStringToDateObjectDayjs(dataOthorK?.ngaySinh),
        ngayNhanKinh: convertIosStringToDateObjectDayjs(
          dataOthorK?.ngayNhanKinh
        ),
        ngayKhamGanNhat: convertIosStringToDateObjectDayjs(
          dataOthorK?.ngayKhamGanNhat
        ),
        ngayGoi: convertIosStringToDateObjectDayjs(dataOthorK?.ngayGoi),
        nhanVien: dataOthorK?.tenBsThucHien,
      });
      // kqdtRef.current.setDataTable(dataKQDT);
    }
  }, [dataOthorK, typeModal]);

  return (
    <Modal
      title={`${typeModal ? "Thêm mới" : "Cập nhật"} bệnh nhân`}
      centered
      open={isShowModal}
      onCancel={handleCancel}
      width={"80%"}
      className="modal-othorK"
      footer=""
      style={{
        margin: "15px 0",
        overflowY: "scroll",
        height: "90%",
      }}
    >
      <div style={{ padding: "0 15px 15px 15px" }}>
        <Form form={form} labelAlign="left" style={{ width: "100%" }}>
          <div>
            <Row justify={"space-between"}>
              <Col flex={"auto"}>
                <Typography.Title>THÔNG TIN BỆNH NHÂN</Typography.Title>
              </Col>
              <Col
                span={3}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button type="primary" onClick={handleSubmit}>
                  {typeModal ? "Lưu" : "Cập nhật"} phiếu
                </Button>
              </Col>
            </Row>
            <Space direction="vertical" style={{ width: "100%" }}>
              <Row gutter={[16, 8]}>
                <InputFields data={fielOthorK} />
              </Row>
            </Space>
          </div>

          <div className="table-custom-othorK">
            <Row>
              <Typography.Title>THÔNG TIN TRƯỚC ĐIỀU TRỊ</Typography.Title>
            </Row>
            <TruocDieuTri />
          </div>
          <div className="table-custom-othorK">
            <Row>
              <Typography.Title>FITTING</Typography.Title>
            </Row>

            <Fitting />
          </div>

          <KetQuaDieuTri ref={kqdtRef} />
        </Form>
      </div>
    </Modal>
  );
});

export default ModalDetail;
